//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {HeadBar} from '@/components';
import XButton from "vux/src/components/x-button/index";
import {OrderProxy} from "@/http/RequestProxy.class";

export default {
  name: 'booking-fail',
  components: {
    XButton,
    HeadBar,
  },
  data(){
    return {
      query: {},
    };
  },
  created(){
    this.query = this.$route.query;
  },
  methods: {
    /** 返回酒店首页 */
    backToHome(){
      this.$router.push({name: 'hotel'})
    },

    /** 重新预订 */
    resetBook(){
      this.$router.push({name: 'hotel-detail', params: this.query});
    },
  },
}



// WEBPACK FOOTER //
// ./src/views/booking-fail/booking-fail.vue